module.exports = __webpack_public_path__ + "static/meta-83163d37c0dd00782ff2ed5e61999f78.png";